var map = {
	"./": [
		72812,
		9
	],
	"./assets/icons/LoctionMap": [
		86260,
		3,
		6260
	],
	"./assets/icons/LoctionMap.json": [
		86260,
		3,
		6260
	],
	"./assets/icons/back_icon.svg": [
		17950,
		1,
		7950
	],
	"./assets/icons/bagIc.svg": [
		10407,
		1,
		407
	],
	"./assets/icons/buy_now_icon.png": [
		79770,
		1
	],
	"./assets/icons/cart_ic.png": [
		23824,
		1
	],
	"./assets/icons/flaticon/flaticon_swigo.css": [
		67865,
		9,
		7865
	],
	"./assets/icons/flaticon/flaticon_swigo1845.eot": [
		30958,
		1,
		958
	],
	"./assets/icons/flaticon/flaticon_swigo1845.svg": [
		9812,
		1,
		9812
	],
	"./assets/icons/flaticon/flaticon_swigo1845.ttf": [
		80568,
		1,
		568
	],
	"./assets/icons/flaticon/flaticon_swigo1845.woff": [
		16472,
		1,
		6472
	],
	"./assets/icons/flaticon/flaticon_swigo1845.woff2": [
		68202,
		1,
		8202
	],
	"./assets/icons/mobile_nav/cart.svg": [
		7952,
		1,
		7952
	],
	"./assets/icons/mobile_nav/home.svg": [
		97487,
		1,
		7487
	],
	"./assets/icons/mobile_nav/home_active.svg": [
		16024,
		1,
		6024
	],
	"./assets/icons/mobile_nav/shop.svg": [
		82978,
		1,
		2978
	],
	"./assets/icons/parnter.svg": [
		39563,
		1,
		9563
	],
	"./assets/icons/profile/address.svg": [
		52527,
		1,
		2527
	],
	"./assets/icons/profile/address_primary_ic.svg": [
		95527,
		1,
		5527
	],
	"./assets/icons/profile/address_white_ic.svg": [
		33188,
		1,
		3188
	],
	"./assets/icons/profile/help.svg": [
		49780,
		1,
		9780
	],
	"./assets/icons/profile/orders.svg": [
		73274,
		1,
		3274
	],
	"./assets/icons/profile/orders_white_ic.svg": [
		91427,
		1,
		1427
	],
	"./assets/icons/profile/partner.svg": [
		6889,
		1,
		6889
	],
	"./assets/icons/profile/profile.svg": [
		14712,
		1,
		4712
	],
	"./assets/icons/profile_user_ic.png": [
		6235,
		1,
		6235
	],
	"./assets/icons/story_ic.png": [
		33439,
		1
	],
	"./assets/icons/support_ic.png": [
		4789,
		1
	],
	"./assets/icons/svg_icons/closeIc.svg": [
		97653,
		1,
		7653
	],
	"./assets/icons/svg_icons/freedelivery.svg": [
		88177,
		1,
		8177
	],
	"./assets/icons/svg_icons/indiaflag.svg": [
		82482,
		1,
		2482
	],
	"./assets/icons/svg_icons/locationPointer.svg": [
		60509,
		1,
		509
	],
	"./assets/icons/svg_icons/locationPointer1.png": [
		44952,
		1,
		4952
	],
	"./assets/icons/svg_icons/no_address.svg": [
		4215,
		1,
		4215
	],
	"./assets/icons/svg_icons/no_orders.svg": [
		4514,
		1,
		4514
	],
	"./assets/icons/svg_icons/nonveg.png": [
		99660,
		1,
		9660
	],
	"./assets/icons/svg_icons/ontime.svg": [
		15683,
		1,
		5683
	],
	"./assets/icons/svg_icons/payment_mode.svg": [
		65963,
		1,
		5963
	],
	"./assets/icons/svg_icons/quality.svg": [
		73250,
		1,
		3250
	],
	"./assets/icons/svg_icons/veg_ic.png": [
		5772,
		1,
		5772
	],
	"./assets/icons/swiggy.jpg": [
		27491,
		1,
		7491
	],
	"./assets/icons/zomato.jpg": [
		62637,
		1,
		2637
	],
	"./assets/images": [
		25907,
		9,
		5907
	],
	"./assets/images/": [
		25907,
		9,
		5907
	],
	"./assets/images/cart_page.png": [
		6283,
		1,
		6283
	],
	"./assets/images/category/veg.png": [
		9760,
		1,
		9760
	],
	"./assets/images/commitments_icons/2.png": [
		35329,
		1,
		5329
	],
	"./assets/images/commitments_icons/4.png": [
		42231,
		1,
		2231
	],
	"./assets/images/commitments_icons/premium_quality_meat.png": [
		18162,
		1,
		8162
	],
	"./assets/images/commitments_icons/quick_delivery.png": [
		67843,
		1,
		7843
	],
	"./assets/images/commitments_icons/team_work.png": [
		8638,
		1,
		8638
	],
	"./assets/images/default_loader.svg": [
		34508,
		1,
		4508
	],
	"./assets/images/delete.jpg": [
		66094,
		1,
		6094
	],
	"./assets/images/empty_cart.png": [
		2307,
		1,
		2307
	],
	"./assets/images/fast-delivery.png": [
		98032,
		1,
		8032
	],
	"./assets/images/footer/footerBackground.webp": [
		77728,
		1,
		7728
	],
	"./assets/images/footer_logo.webp": [
		24536,
		1
	],
	"./assets/images/franchise.png": [
		90114,
		1,
		114
	],
	"./assets/images/index": [
		25907,
		9,
		5907
	],
	"./assets/images/index.js": [
		25907,
		9,
		5907
	],
	"./assets/images/loaders/round_loader.svg": [
		21070,
		1,
		1070
	],
	"./assets/images/logo.webp": [
		11238,
		1
	],
	"./assets/images/logout.jpg": [
		77313,
		1
	],
	"./assets/images/marker.png": [
		62333,
		1,
		2333
	],
	"./assets/images/mobile_login.jpg": [
		82679,
		1,
		2679
	],
	"./assets/images/no_data.jpg": [
		28443,
		1,
		8443
	],
	"./assets/images/ourstory/story_img.webp": [
		72244,
		1,
		2244
	],
	"./assets/images/pan1.png": [
		49037,
		1,
		9037
	],
	"./assets/images/pan2.png": [
		18710,
		1,
		8710
	],
	"./assets/images/placeholder_image.png": [
		9258,
		1,
		9258
	],
	"./assets/images/premium_seller_bg.webp": [
		46246,
		1,
		6246
	],
	"./assets/images/premiumproducts/bg.png": [
		14804,
		1,
		4804
	],
	"./assets/images/product-not-found.jpg": [
		14281,
		1,
		4281
	],
	"./assets/images/product_dummy.png": [
		36023,
		1,
		6023
	],
	"./assets/images/products/nonveg.png": [
		73009,
		1,
		3009
	],
	"./assets/images/products/veg.png": [
		18636,
		1,
		8636
	],
	"./assets/images/profile_no_order.jpg": [
		99777,
		1,
		9777
	],
	"./assets/images/shape-1.png": [
		34658,
		1,
		4658
	],
	"./assets/images/shape-2.png": [
		48665,
		1,
		8665
	],
	"./assets/images/success_order.gif": [
		59804,
		1,
		9804
	],
	"./assets/images/testimonials/arrow-down.png": [
		24820,
		1,
		4820
	],
	"./assets/images/testimonials/arrow-up.png": [
		20971,
		1,
		971
	],
	"./assets/scss/app.scss": [
		88604,
		9
	],
	"./assets/scss/custom/components/_abstract.scss": [
		92687,
		9,
		2687
	],
	"./assets/scss/custom/components/_accordion.scss": [
		91133,
		9,
		1133
	],
	"./assets/scss/custom/components/_alert.scss": [
		39297,
		9,
		9297
	],
	"./assets/scss/custom/components/_askLocation.scss": [
		43917,
		9,
		3917
	],
	"./assets/scss/custom/components/_breadcrumb.scss": [
		56128,
		9,
		6128
	],
	"./assets/scss/custom/components/_button.scss": [
		10533,
		9,
		533
	],
	"./assets/scss/custom/components/_card.scss": [
		54923,
		9,
		4923
	],
	"./assets/scss/custom/components/_carousel.scss": [
		55487,
		9,
		5487
	],
	"./assets/scss/custom/components/_collapse.scss": [
		46430,
		9,
		6430
	],
	"./assets/scss/custom/components/_datatable.scss": [
		91723,
		9,
		1723
	],
	"./assets/scss/custom/components/_deliveryLocation.scss": [
		22394,
		9,
		2394
	],
	"./assets/scss/custom/components/_dropdown.scss": [
		33460,
		9,
		3460
	],
	"./assets/scss/custom/components/_form.scss": [
		65471,
		9,
		5471
	],
	"./assets/scss/custom/components/_icon.scss": [
		54196,
		9,
		4196
	],
	"./assets/scss/custom/components/_input.scss": [
		83447,
		9,
		3447
	],
	"./assets/scss/custom/components/_list.scss": [
		52237,
		9,
		2237
	],
	"./assets/scss/custom/components/_menu.scss": [
		55938,
		9,
		5938
	],
	"./assets/scss/custom/components/_menusticky.scss": [
		62377,
		9,
		2377
	],
	"./assets/scss/custom/components/_mobilemenu.scss": [
		4316,
		9,
		4316
	],
	"./assets/scss/custom/components/_mobilepopup.scss": [
		26675,
		9,
		6675
	],
	"./assets/scss/custom/components/_modal.scss": [
		15418,
		9,
		5418
	],
	"./assets/scss/custom/components/_navbar.scss": [
		62879,
		9,
		2879
	],
	"./assets/scss/custom/components/_offcanvas.scss": [
		68426,
		9,
		8426
	],
	"./assets/scss/custom/components/_overlay.scss": [
		35871,
		9,
		5871
	],
	"./assets/scss/custom/components/_pagetitle.scss": [
		22096,
		9,
		2096
	],
	"./assets/scss/custom/components/_pagination.scss": [
		5689,
		9,
		5689
	],
	"./assets/scss/custom/components/_preloader.scss": [
		7969,
		9,
		7969
	],
	"./assets/scss/custom/components/_progressbar.scss": [
		76623,
		9,
		6623
	],
	"./assets/scss/custom/components/_skeleton.scss": [
		74714,
		9,
		4714
	],
	"./assets/scss/custom/components/_spinner.scss": [
		68694,
		9,
		8694
	],
	"./assets/scss/custom/components/_tab.scss": [
		28268,
		9,
		8268
	],
	"./assets/scss/custom/components/_table.scss": [
		3731,
		9,
		3731
	],
	"./assets/scss/custom/components/_text.scss": [
		74826,
		9,
		4826
	],
	"./assets/scss/custom/components/_toast.scss": [
		77148,
		9,
		7148
	],
	"./assets/scss/custom/components/_tooltips.scss": [
		81149,
		9,
		1149
	],
	"./assets/scss/custom/components/_widget.scss": [
		70109,
		9,
		109
	],
	"./assets/scss/custom/pages/_about.scss": [
		68900,
		9,
		8900
	],
	"./assets/scss/custom/pages/_blog.scss": [
		58611,
		9,
		8611
	],
	"./assets/scss/custom/pages/_cart.scss": [
		91173,
		9,
		1173
	],
	"./assets/scss/custom/pages/_categories.scss": [
		97079,
		9,
		7079
	],
	"./assets/scss/custom/pages/_home.scss": [
		94004,
		9,
		4004
	],
	"./assets/scss/custom/pages/_login.scss": [
		12944,
		9,
		2944
	],
	"./assets/scss/custom/pages/_map.scss": [
		40979,
		9,
		979
	],
	"./assets/scss/custom/pages/_product.scss": [
		97446,
		9,
		7446
	],
	"./assets/scss/custom/pages/_product_detail.scss": [
		75290,
		9,
		5290
	],
	"./assets/scss/custom/pages/_profile.scss": [
		42580,
		9,
		2580
	],
	"./assets/scss/custom/pages/_service.scss": [
		93742,
		9,
		3742
	],
	"./assets/scss/custom/pages/_staticPages.scss": [
		7979,
		9,
		7979
	],
	"./assets/scss/custom/pages/_team.scss": [
		47366,
		9,
		7366
	],
	"./assets/scss/custom/pages/_testimonial.scss": [
		99722,
		9,
		9722
	],
	"./assets/scss/custom/pages/_tracking.scss": [
		49814,
		9,
		9814
	],
	"./assets/scss/custom/pages/_user.scss": [
		62992,
		9,
		2992
	],
	"./assets/scss/custom/structure/_denznav.scss": [
		93310,
		9,
		3310
	],
	"./assets/scss/custom/structure/_footer.scss": [
		37493,
		9,
		7493
	],
	"./assets/scss/custom/structure/_header.scss": [
		96323,
		9,
		6323
	],
	"./assets/scss/custom/structure/_layout.scss": [
		57496,
		9,
		7496
	],
	"./assets/scss/custom/structure/_main.scss": [
		73219,
		9,
		3219
	],
	"./assets/scss/custom/structure/_mobileMenu.scss": [
		93139,
		9,
		3139
	],
	"./assets/scss/custom/structure/_sidebar.scss": [
		70818,
		9,
		818
	],
	"./assets/scss/general.scss": [
		78907,
		9,
		8907
	],
	"./assets/scss/global.scss": [
		85834,
		9,
		5834
	],
	"./components/Footer": [
		49748,
		9
	],
	"./components/Footer/": [
		49748,
		9
	],
	"./components/Footer/index": [
		49748,
		9
	],
	"./components/Footer/index.jsx": [
		49748,
		9
	],
	"./components/FormInput": [
		16300,
		9,
		6300
	],
	"./components/FormInput/": [
		16300,
		9,
		6300
	],
	"./components/FormInput/customInput": [
		30337,
		9
	],
	"./components/FormInput/customInput.js": [
		30337,
		9
	],
	"./components/FormInput/index": [
		16300,
		9,
		6300
	],
	"./components/FormInput/index.js": [
		16300,
		9,
		6300
	],
	"./components/FormInput/passwordInput": [
		37823,
		9,
		7823
	],
	"./components/FormInput/passwordInput.js": [
		37823,
		9,
		7823
	],
	"./components/authentication": [
		70570,
		9
	],
	"./components/authentication/": [
		70570,
		9
	],
	"./components/authentication/LoginFormComponent": [
		29286,
		9
	],
	"./components/authentication/LoginFormComponent.jsx": [
		29286,
		9
	],
	"./components/authentication/RegisterFormComponent": [
		13032,
		9
	],
	"./components/authentication/RegisterFormComponent.jsx": [
		13032,
		9
	],
	"./components/authentication/index": [
		70570,
		9
	],
	"./components/authentication/index.jsx": [
		70570,
		9
	],
	"./components/buttons/LoadingButton": [
		7903,
		9
	],
	"./components/buttons/LoadingButton.js": [
		7903,
		9
	],
	"./components/dropdown": [
		6937,
		9
	],
	"./components/dropdown/": [
		6937,
		9
	],
	"./components/dropdown/Avatar": [
		92291,
		9
	],
	"./components/dropdown/Avatar/": [
		92291,
		9
	],
	"./components/dropdown/Avatar/avatar.scss": [
		5574,
		9
	],
	"./components/dropdown/Avatar/index": [
		92291,
		9
	],
	"./components/dropdown/Avatar/index.jsx": [
		92291,
		9
	],
	"./components/dropdown/index": [
		6937,
		9
	],
	"./components/dropdown/index.jsx": [
		6937,
		9
	],
	"./components/header/header": [
		96418,
		9
	],
	"./components/header/header.jsx": [
		96418,
		9
	],
	"./components/loaders/defaultLoader": [
		53091,
		9,
		3091
	],
	"./components/loaders/defaultLoader.js": [
		53091,
		9,
		3091
	],
	"./components/loaders/fullScreenLoader": [
		32590,
		9,
		2590
	],
	"./components/loaders/fullScreenLoader.js": [
		32590,
		9,
		2590
	],
	"./components/loaders/style.scss": [
		91255,
		9,
		1255
	],
	"./components/map": [
		6464,
		9
	],
	"./components/map/": [
		6464,
		9
	],
	"./components/map/AskLocation": [
		27571,
		9
	],
	"./components/map/AskLocation.js": [
		27571,
		9
	],
	"./components/map/MapComponent": [
		26281,
		9
	],
	"./components/map/MapComponent.jsx": [
		26281,
		9
	],
	"./components/map/index": [
		6464,
		9
	],
	"./components/map/index.jsx": [
		6464,
		9
	],
	"./components/mobileMenu": [
		50677,
		9
	],
	"./components/mobileMenu/": [
		50677,
		9
	],
	"./components/mobileMenu/index": [
		50677,
		9
	],
	"./components/mobileMenu/index.jsx": [
		50677,
		9
	],
	"./components/popup/CancelOrder": [
		54314,
		9,
		4314
	],
	"./components/popup/CancelOrder.jsx": [
		54314,
		9,
		4314
	],
	"./components/popup/CartPopup": [
		30764,
		9,
		764
	],
	"./components/popup/CartPopup.jsx": [
		30764,
		9,
		764
	],
	"./components/popup/DeletePopup": [
		65993,
		9,
		5993
	],
	"./components/popup/DeletePopup.jsx": [
		65993,
		9,
		5993
	],
	"./components/popup/LogoutPopup": [
		19960,
		9
	],
	"./components/popup/LogoutPopup.jsx": [
		19960,
		9
	],
	"./components/popup/upiPaymentDesktop": [
		16406,
		9,
		1614,
		6406
	],
	"./components/popup/upiPaymentDesktop.js": [
		16406,
		9,
		1614,
		6406
	],
	"./components/popup/upiPaymentMobile": [
		83394,
		9,
		3394
	],
	"./components/popup/upiPaymentMobile.js": [
		83394,
		9,
		3394
	],
	"./components/products/productCard": [
		18547,
		9,
		8547
	],
	"./components/products/productCard.js": [
		18547,
		9,
		8547
	],
	"./components/sidebar": [
		32306,
		9
	],
	"./components/sidebar/": [
		32306,
		9
	],
	"./components/sidebar/MenuItem": [
		81612,
		9,
		9231
	],
	"./components/sidebar/MenuItem.jsx": [
		81612,
		9,
		9231
	],
	"./components/sidebar/index": [
		32306,
		9
	],
	"./components/sidebar/index.jsx": [
		32306,
		9
	],
	"./components/skeleton/CategorySkeleton": [
		72058,
		9,
		2058
	],
	"./components/skeleton/CategorySkeleton.jsx": [
		72058,
		9,
		2058
	],
	"./components/slider/homeProduct/ProductSlider": [
		34912,
		9,
		6441,
		4912
	],
	"./components/slider/homeProduct/ProductSlider.jsx": [
		34912,
		9,
		6441,
		4912
	],
	"./components/slider/withoutAutoplay": [
		22151,
		9,
		6441,
		2151
	],
	"./components/slider/withoutAutoplay/": [
		22151,
		9,
		6441,
		2151
	],
	"./components/slider/withoutAutoplay/index": [
		22151,
		9,
		6441,
		2151
	],
	"./components/slider/withoutAutoplay/index.jsx": [
		22151,
		9,
		6441,
		2151
	],
	"./config": [
		93488,
		9
	],
	"./config.js": [
		93488,
		9
	],
	"./context/AddressContext": [
		23733,
		9
	],
	"./context/AddressContext.js": [
		23733,
		9
	],
	"./context/AuthContext": [
		8729,
		9
	],
	"./context/AuthContext.js": [
		8729,
		9
	],
	"./context/CartContext": [
		65169,
		9
	],
	"./context/CartContext.js": [
		65169,
		9
	],
	"./helpers": [
		98402,
		9
	],
	"./helpers/": [
		98402,
		9
	],
	"./helpers/CartContext": [
		75611,
		9,
		5611
	],
	"./helpers/CartContext.js": [
		75611,
		9,
		5611
	],
	"./helpers/CodeSplitter": [
		29142,
		9
	],
	"./helpers/CodeSplitter.js": [
		29142,
		9
	],
	"./helpers/ErrorBoundary": [
		73226,
		9
	],
	"./helpers/ErrorBoundary.jsx": [
		73226,
		9
	],
	"./helpers/ErrorBoundaryFC": [
		40443,
		9
	],
	"./helpers/ErrorBoundaryFC.jsx": [
		40443,
		9
	],
	"./helpers/events": [
		45321,
		9,
		5321
	],
	"./helpers/events.js": [
		45321,
		9,
		5321
	],
	"./helpers/index": [
		98402,
		9
	],
	"./helpers/index.js": [
		98402,
		9
	],
	"./helpers/scrollTop": [
		91646,
		9
	],
	"./helpers/scrollTop.js": [
		91646,
		9
	],
	"./helpers/utis": [
		51397,
		9
	],
	"./helpers/utis.js": [
		51397,
		9
	],
	"./helpers/variables": [
		66251,
		9
	],
	"./helpers/variables.js": [
		66251,
		9
	],
	"./index": [
		72812,
		9
	],
	"./index.js": [
		72812,
		9
	],
	"./layout": [
		58661,
		9
	],
	"./layout/": [
		58661,
		9
	],
	"./layout/AuthLayout": [
		84273,
		9
	],
	"./layout/AuthLayout.jsx": [
		84273,
		9
	],
	"./layout/MainLayout": [
		44488,
		9
	],
	"./layout/MainLayout.jsx": [
		44488,
		9
	],
	"./layout/index": [
		58661,
		9
	],
	"./layout/index.jsx": [
		58661,
		9
	],
	"./pages/cart": [
		70850,
		9,
		8441,
		9853,
		1614,
		9401,
		8061,
		137,
		2723,
		8608,
		1193
	],
	"./pages/cart/": [
		70850,
		9,
		8441,
		9853,
		1614,
		9401,
		8061,
		137,
		2723,
		8608,
		1193
	],
	"./pages/cart/AddonPopup": [
		16624,
		9,
		8877,
		6624
	],
	"./pages/cart/AddonPopup.jsx": [
		16624,
		9,
		8877,
		6624
	],
	"./pages/cart/AddressComponent": [
		62021,
		9,
		8441,
		137,
		5485
	],
	"./pages/cart/AddressComponent.jsx": [
		62021,
		9,
		8441,
		137,
		5485
	],
	"./pages/cart/AddressEditPopup": [
		42758,
		9,
		2758
	],
	"./pages/cart/AddressEditPopup.jsx": [
		42758,
		9,
		2758
	],
	"./pages/cart/DesktopLayout": [
		50844,
		9,
		8441,
		9853,
		1614,
		9401,
		8061,
		137,
		2723,
		5291
	],
	"./pages/cart/DesktopLayout.jsx": [
		50844,
		9,
		8441,
		9853,
		1614,
		9401,
		8061,
		137,
		2723,
		5291
	],
	"./pages/cart/MobileAddress": [
		42196,
		9,
		8441,
		1612
	],
	"./pages/cart/MobileAddress.jsx": [
		42196,
		9,
		8441,
		1612
	],
	"./pages/cart/MobileLayout": [
		58608,
		9,
		8441,
		9853,
		1614,
		9401,
		8061,
		8608,
		1452
	],
	"./pages/cart/MobileLayout.jsx": [
		58608,
		9,
		8441,
		9853,
		1614,
		9401,
		8061,
		8608,
		1452
	],
	"./pages/cart/PaymentPage": [
		93967,
		9,
		1614,
		9401,
		3967
	],
	"./pages/cart/PaymentPage.js": [
		93967,
		9,
		1614,
		9401,
		3967
	],
	"./pages/cart/SideMenuComponent": [
		2723,
		9,
		2723,
		2032
	],
	"./pages/cart/SideMenuComponent.jsx": [
		2723,
		9,
		2723,
		2032
	],
	"./pages/cart/SuccessOrder": [
		2815,
		9,
		9853,
		8061,
		2815
	],
	"./pages/cart/SuccessOrder.jsx": [
		2815,
		9,
		9853,
		8061,
		2815
	],
	"./pages/cart/index": [
		70850,
		9,
		8441,
		9853,
		1614,
		9401,
		8061,
		137,
		2723,
		8608,
		1193
	],
	"./pages/cart/index.jsx": [
		70850,
		9,
		8441,
		9853,
		1614,
		9401,
		8061,
		137,
		2723,
		8608,
		1193
	],
	"./pages/categories": [
		6120,
		9,
		6120
	],
	"./pages/categories/": [
		6120,
		9,
		6120
	],
	"./pages/categories/DeskTopLayout": [
		85746,
		9,
		5746
	],
	"./pages/categories/DeskTopLayout.js": [
		85746,
		9,
		5746
	],
	"./pages/categories/MobileLayout": [
		11222,
		9,
		1222
	],
	"./pages/categories/MobileLayout.js": [
		11222,
		9,
		1222
	],
	"./pages/categories/index": [
		6120,
		9,
		6120
	],
	"./pages/categories/index.js": [
		6120,
		9,
		6120
	],
	"./pages/home": [
		2445,
		9,
		6441,
		2445
	],
	"./pages/home/": [
		2445,
		9,
		6441,
		2445
	],
	"./pages/home/HomeSlider": [
		27885,
		9,
		6441,
		7885
	],
	"./pages/home/HomeSlider.js": [
		27885,
		9,
		6441,
		7885
	],
	"./pages/home/categories": [
		36432,
		9,
		6432
	],
	"./pages/home/categories/": [
		36432,
		9,
		6432
	],
	"./pages/home/categories/index": [
		36432,
		9,
		6432
	],
	"./pages/home/categories/index.js": [
		36432,
		9,
		6432
	],
	"./pages/home/index": [
		2445,
		9,
		6441,
		2445
	],
	"./pages/home/index.jsx": [
		2445,
		9,
		6441,
		2445
	],
	"./pages/home/products/addon/AddOnPopup": [
		74359,
		9,
		4359
	],
	"./pages/home/products/addon/AddOnPopup.jsx": [
		74359,
		9,
		4359
	],
	"./pages/home/products/addon/MobileAddOnpopup": [
		46805,
		9,
		8877,
		6805
	],
	"./pages/home/products/addon/MobileAddOnpopup.jsx": [
		46805,
		9,
		8877,
		6805
	],
	"./pages/home/products/instagram": [
		66232,
		9,
		6232
	],
	"./pages/home/products/instagram.jsx": [
		66232,
		9,
		6232
	],
	"./pages/home/products/layout/ProductsDesktopLayout": [
		43887,
		9,
		3887
	],
	"./pages/home/products/layout/ProductsDesktopLayout.jsx": [
		43887,
		9,
		3887
	],
	"./pages/orderTracking": [
		8389,
		9,
		7196,
		2639,
		8389
	],
	"./pages/orderTracking/": [
		8389,
		9,
		7196,
		2639,
		8389
	],
	"./pages/orderTracking/index": [
		8389,
		9,
		7196,
		2639,
		8389
	],
	"./pages/orderTracking/index.jsx": [
		8389,
		9,
		7196,
		2639,
		8389
	],
	"./pages/orderTracking/map": [
		81999,
		9,
		1999
	],
	"./pages/orderTracking/map.js": [
		81999,
		9,
		1999
	],
	"./pages/productDetail": [
		18786,
		9,
		6441,
		8786
	],
	"./pages/productDetail/": [
		18786,
		9,
		6441,
		8786
	],
	"./pages/productDetail/index": [
		18786,
		9,
		6441,
		8786
	],
	"./pages/productDetail/index.jsx": [
		18786,
		9,
		6441,
		8786
	],
	"./pages/profile": [
		15675,
		9,
		8877,
		7196,
		9698,
		1906,
		6546,
		80,
		4682,
		1950
	],
	"./pages/profile/": [
		15675,
		9,
		8877,
		7196,
		9698,
		1906,
		6546,
		80,
		4682,
		1950
	],
	"./pages/profile/ProfileDesktop": [
		64682,
		9,
		8877,
		9698,
		1906,
		6546,
		4682,
		5846
	],
	"./pages/profile/ProfileDesktop.jsx": [
		64682,
		9,
		8877,
		9698,
		1906,
		6546,
		4682,
		5846
	],
	"./pages/profile/ProfileMobile": [
		80080,
		9,
		7196,
		80,
		8715
	],
	"./pages/profile/ProfileMobile.jsx": [
		80080,
		9,
		7196,
		80,
		8715
	],
	"./pages/profile/SidebarMenum": [
		65983,
		9,
		9698,
		5983
	],
	"./pages/profile/SidebarMenum.js": [
		65983,
		9,
		9698,
		5983
	],
	"./pages/profile/index": [
		15675,
		9,
		8877,
		7196,
		9698,
		1906,
		6546,
		80,
		4682,
		1950
	],
	"./pages/profile/index.jsx": [
		15675,
		9,
		8877,
		7196,
		9698,
		1906,
		6546,
		80,
		4682,
		1950
	],
	"./pages/profile/mobileLayout/address": [
		94030,
		9,
		6546,
		4030
	],
	"./pages/profile/mobileLayout/address.js": [
		94030,
		9,
		6546,
		4030
	],
	"./pages/profile/mobileLayout/orders": [
		48873,
		9,
		8877,
		1906,
		8873
	],
	"./pages/profile/mobileLayout/orders.js": [
		48873,
		9,
		8877,
		1906,
		8873
	],
	"./pages/profile/profileSidebar/EditProfile": [
		80888,
		9,
		888
	],
	"./pages/profile/profileSidebar/EditProfile.jsx": [
		80888,
		9,
		888
	],
	"./pages/staticPages/about": [
		12511,
		9,
		2511
	],
	"./pages/staticPages/about.js": [
		12511,
		9,
		2511
	],
	"./pages/staticPages/faq": [
		99994,
		9,
		9994
	],
	"./pages/staticPages/faq.js": [
		99994,
		9,
		9994
	],
	"./pages/staticPages/franchise": [
		70909,
		9,
		909
	],
	"./pages/staticPages/franchise.js": [
		70909,
		9,
		909
	],
	"./pages/staticPages/help": [
		14879,
		9,
		4879
	],
	"./pages/staticPages/help.js": [
		14879,
		9,
		4879
	],
	"./pages/staticPages/privacy": [
		44558,
		9,
		4558
	],
	"./pages/staticPages/privacy.js": [
		44558,
		9,
		4558
	],
	"./pages/staticPages/team": [
		66197,
		9,
		6197
	],
	"./pages/staticPages/team.js": [
		66197,
		9,
		6197
	],
	"./pages/staticPages/terms": [
		24817,
		9,
		4817
	],
	"./pages/staticPages/terms.js": [
		24817,
		9,
		4817
	],
	"./pages/staticPages/testimonials": [
		65268,
		9,
		6441,
		5268
	],
	"./pages/staticPages/testimonials.js": [
		65268,
		9,
		6441,
		5268
	],
	"./redux/reducer/home/homeAPI": [
		38465,
		9
	],
	"./redux/reducer/home/homeAPI.js": [
		38465,
		9
	],
	"./redux/reducer/home/homeSlice": [
		3159,
		9
	],
	"./redux/reducer/home/homeSlice.js": [
		3159,
		9
	],
	"./reportWebVitals": [
		89031,
		9,
		9031
	],
	"./reportWebVitals.js": [
		89031,
		9,
		9031
	],
	"./routes": [
		86807,
		9
	],
	"./routes/": [
		86807,
		9
	],
	"./routes/index": [
		86807,
		9
	],
	"./routes/index.js": [
		86807,
		9
	],
	"./routes/routes": [
		79297,
		9
	],
	"./routes/routes.js": [
		79297,
		9
	],
	"./service/api": [
		37068,
		9
	],
	"./service/api.js": [
		37068,
		9
	],
	"./service/apiVariables": [
		21375,
		9
	],
	"./service/apiVariables.js": [
		21375,
		9
	],
	"./service/toast": [
		27615,
		9
	],
	"./service/toast.js": [
		27615,
		9
	],
	"./service/utilities": [
		22503,
		9
	],
	"./service/utilities.js": [
		22503,
		9
	],
	"./setupTests": [
		89472,
		9,
		9853,
		1405,
		9472
	],
	"./setupTests.js": [
		89472,
		9,
		9853,
		1405,
		9472
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59140;
module.exports = webpackAsyncContext;